import { render, staticRenderFns } from "./aeDetail.vue?vue&type=template&id=e24305ec&"
import script from "./aeDetail.vue?vue&type=script&lang=js&"
export * from "./aeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e24305ec')) {
      api.createRecord('e24305ec', component.options)
    } else {
      api.reload('e24305ec', component.options)
    }
    module.hot.accept("./aeDetail.vue?vue&type=template&id=e24305ec&", function () {
      api.rerender('e24305ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/aeDetail.vue"
export default component.exports